import React, { FC } from 'react';
import { Box } from '@chakra-ui/react';

const ControlButton: FC<{
    onClick: () => void;
    ariaLabel: string;
    bg?: string;
    w?: string;
    h?: string;
    children: React.ReactNode;
}> = ({ onClick, ariaLabel, bg = 'transparent', w = 'auto', h = 'auto', children }) => (
    <Box
        as="button"
        onClick={onClick}
        aria-label={ariaLabel}
        p="8px"
        rounded="4px"
        bg={bg}
        border="none"
        cursor="pointer"
        color="white"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        w={w}
        h={h}
        _hover={{ bg: bg === 'transparent' ? 'whiteAlpha.200' : 'blackAlpha.800' }}
    >
        {children}
    </Box>
);

export default ControlButton;
